var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordnotmatched(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 450,
    height: 354.223,
    viewBox: "0 0 450 354.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5253",
    "data-name": "Rectangle 5253",
    width: 18.371,
    height: 28.973,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5254",
    "data-name": "Rectangle 5254",
    width: 8.722,
    height: 12.26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5255",
    "data-name": "Rectangle 5255",
    width: 7.698,
    height: 41.666,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5256",
    "data-name": "Rectangle 5256",
    width: 13.102,
    height: 14.362,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5257",
    "data-name": "Rectangle 5257",
    width: 51.084,
    height: 63.915,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5258",
    "data-name": "Rectangle 5258",
    width: 6.356,
    height: 18.337,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5259",
    "data-name": "Rectangle 5259",
    width: 10.129,
    height: 11.014,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5260",
    "data-name": "Rectangle 5260",
    width: 45.277,
    height: 52.067,
    fill: "#55deaa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5261",
    "data-name": "Rectangle 5261",
    width: 26.511,
    height: 46.644,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5263",
    "data-name": "Rectangle 5263",
    width: 20.962,
    height: 29.619,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5265",
    "data-name": "Rectangle 5265",
    width: 15.67,
    height: 15.855,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5266",
    "data-name": "Rectangle 5266",
    width: 13.144,
    height: 43.416,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5267",
    "data-name": "Rectangle 5267",
    width: 14.159,
    height: 11.472,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5268",
    "data-name": "Rectangle 5268",
    width: 13.759,
    height: 28.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5269",
    "data-name": "Rectangle 5269",
    width: 13.01,
    height: 11.368,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5270",
    "data-name": "Rectangle 5270",
    width: 58.099,
    height: 58.099,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5271",
    "data-name": "Rectangle 5271",
    width: 40.301,
    height: 40.301,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9538",
    "data-name": "Group 9538",
    transform: "translate(16383.278 15250.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6468",
    "data-name": "Path 6468",
    d: "M439.159,302.5c0,7.1-98.309,12.855-219.58,12.855S0,309.6,0,302.5,98.309,289.64,219.58,289.64s219.58,5.756,219.58,12.855",
    transform: "translate(-16382.795 -15211.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5252",
    "data-name": "Rectangle 5252",
    width: 450,
    height: 354.223,
    transform: "translate(-16383.278 -15250.487)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6469",
    "data-name": "Path 6469",
    d: "M82.173,31.9c-9.152,9.2,6.407,23.5-3.873,30.054,8.384,4.218,37.794,9.564,45.37-7-5.551-4.313-1.7-14.926-6.821-25.1-7.608-15.107-43.828-8.421-34.676,2.044",
    transform: "translate(-16372.443 -15247.337)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6470",
    "data-name": "Path 6470",
    d: "M83.384,30.4c-2.854-.479-12.475,4.317-5.318,17.181,5.781,10.392.967,11.135.967,11.135s5.71.16,2.3-7.571C77.7,42.887,76,34.323,83.384,30.4",
    transform: "translate(-16372.788 -15246.072)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6471",
    "data-name": "Path 6471",
    d: "M146.559,106.608a2.772,2.772,0,0,0-3.74-1.172l-.676.354c-.211.11-.622.385-.954.569-.346.21-.706.41-1.069.594a17.975,17.975,0,0,1-2.22.938,13.93,13.93,0,0,1-4.366.822,11.842,11.842,0,0,1-4.029-.648,14.669,14.669,0,0,1-2.381-1.108c-.973-2.159-1.9-4.339-2.7-6.584-.965-2.627-1.811-5.309-2.558-8.022s-1.408-5.453-1.956-8.213c-.284-1.376-.536-2.758-.761-4.136l-.3-2.056c-.1-.661-.2-1.4-.255-1.924l-.026-.226a5.675,5.675,0,0,0-11.292,1.121c.076.958.15,1.7.249,2.511s.22,1.577.334,2.363q.376,2.34.845,4.647a89.937,89.937,0,0,0,2.384,9.1c.45,1.5,1,2.981,1.507,4.466.586,1.465,1.122,2.942,1.773,4.382a84.233,84.233,0,0,0,4.215,8.5l.14.252a4.394,4.394,0,0,0,1.759,1.751,23.032,23.032,0,0,0,6.872,2.433,19.214,19.214,0,0,0,7.442-.162,19.7,19.7,0,0,0,6.53-2.838,21.111,21.111,0,0,0,2.66-2.142c.412-.386.807-.785,1.19-1.2.4-.446.7-.823,1.143-1.413a2.778,2.778,0,0,0,.245-2.956",
    transform: "translate(-16368.601 -15240.845)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6472",
    "data-name": "Path 6472",
    d: "M149.913,92.979l-.327-.008a7.066,7.066,0,0,0-5.695,2.661l-5.483,6.879-.046,4.7c4.4,1.747,9.991-2.969,9.991-2.969l2.826-.707a3.955,3.955,0,0,0,2.955-4.4l-.4-2.766a3.957,3.957,0,0,0-3.822-3.389",
    transform: "translate(-16364.466 -15237.893)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6473",
    "data-name": "Path 6473",
    d: "M118.841,69.86c3.667,3.767,3.9,15.023,3.9,15.023l-14.677,11.8s-6.018-16.68-2.69-22.574c2.827-5,8.794-9.049,13.466-4.251",
    transform: "translate(-16368.969 -15241.24)",
    fill: "#e89f33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9480",
    "data-name": "Group 9480",
    transform: "translate(-16264.6 -15173.53)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9479",
    "data-name": "Group 9479",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9478",
    "data-name": "Group 9478",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6474",
    "data-name": "Path 6474",
    d: "M118.841,69.86c3.667,3.767,3.9,15.023,3.9,15.023l-14.677,11.8s-6.018-16.68-2.69-22.574c2.827-5,8.794-9.049,13.466-4.251",
    transform: "translate(-104.371 -67.711)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6475",
    "data-name": "Path 6475",
    d: "M95.741,295.016l8.1.895,1.111-22.03-8.1-.893Z",
    transform: "translate(-16370.11 -15214.175)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6476",
    "data-name": "Path 6476",
    d: "M105.353,288.51H95.825a.733.733,0,0,0-.758.693l-.633,9.01a1.787,1.787,0,0,0,1.758,1.8c4.02.036,4.059.019,9.067.019h13.519c4.161,0,4.171-4.207,2.372-4.588-8.069-1.709-11.215-4.064-14.055-6.312a2.835,2.835,0,0,0-1.74-.623",
    transform: "translate(-16370.299 -15212.079)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9483",
    "data-name": "Group 9483",
    transform: "translate(-16273.879 -14941.183)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9482",
    "data-name": "Group 9482",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9481",
    "data-name": "Group 9481",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6477",
    "data-name": "Path 6477",
    d: "M104.893,273.886l-.571,11.356-8.15.01.616-12.26Z",
    transform: "translate(-96.171 -272.991)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    d: "M111.084,119.425s7,58.733,7,84.845c-5.528,36.33-10.2,100.088-10.2,100.088l-11.224-.288s-5.1-69.444-.369-99.42c-6.055-26.87-13.526-88.855-13.526-88.855Z",
    transform: "translate(-16371.842 -15235.445)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9486",
    "data-name": "Group 9486",
    transform: "translate(-16286.254 -15099.188)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9485",
    "data-name": "Group 9485",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9484",
    "data-name": "Group 9484",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6479",
    "data-name": "Path 6479",
    d: "M89.126,133.4a33.516,33.516,0,0,0-3.883,2.021c1.544,11.592,3.576,26.181,5.733,39.645,3.678-11.081,1.692-35.445-1.851-41.666",
    transform: "translate(-85.243 -133.395)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6480",
    "data-name": "Path 6480",
    d: "M18.422,276.622,25.1,281.29l11.533-18.8-6.683-4.667Z",
    transform: "translate(-16380.305 -15216.228)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6481",
    "data-name": "Path 6481",
    d: "M27.592,277.272,21.9,269.634a.734.734,0,0,0-1.008-.193l-7.6,4.876a1.79,1.79,0,0,0-.4,2.487c2.375,3.244,2.411,3.265,5.405,7.28l8.082,10.838c2.487,3.335,5.866.83,5.1-.841-3.454-7.49-3.446-11.42-3.342-15.041a2.83,2.83,0,0,0-.54-1.768",
    transform: "translate(-16381.096 -15214.672)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9489",
    "data-name": "Group 9489",
    transform: "translate(-16356.772 -14958.404)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9488",
    "data-name": "Group 9488",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9487",
    "data-name": "Group 9487",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    d: "M36.024,262.492l-5.943,9.692-7.158-3.9,6.417-10.464Z",
    transform: "translate(-22.922 -257.822)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6483",
    "data-name": "Path 6483",
    d: "M56.708,296.724c-5.8,0-17.884,0-18.087-8.539-.16-6.7,8.13-9.478,15.276-9.819a6.029,6.029,0,0,1,6.323,5.746c.007.151.009.3,0,.452,8.1-.385,13.35-2.155,15.268-5.177,4.327-6.821-3.955-24.4-11.966-41.4-9.418-19.989-20.091-42.642-20.3-64.333a6.041,6.041,0,0,1,5.982-6.1h.059a6.042,6.042,0,0,1,6.04,5.981c.183,19.05,10.259,40.435,19.148,59.3,10.261,21.779,19.125,40.589,11.239,53.02-4.638,7.313-14.119,10.867-28.985,10.867",
    transform: "translate(-16377.563 -15228.443)",
    fill: "#3b9a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6484",
    "data-name": "Path 6484",
    d: "M110.2,118.432S90.833,185.549,81.37,209.887c-18.317,31.858-48.721,80.624-48.721,80.624l-9.713-5.632s22.713-56.311,37.983-82.537c4.094-27.238,19.592-87.717,19.592-87.717Z",
    transform: "translate(-16379.69 -15235.604)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6485",
    "data-name": "Path 6485",
    d: "M27.527,281.53a3.285,3.285,0,0,0,1.69,1.377,1.153,1.153,0,0,0,1.089-.37.839.839,0,0,0,.25-.7c-.144-1.361-3.657-3.128-4.36-3.468a.188.188,0,0,0-.235.073.3.3,0,0,0-.027.292,16.382,16.382,0,0,0,1.593,2.8m2.419-.042a.924.924,0,0,1,.2.431.263.263,0,0,1-.094.234.787.787,0,0,1-.753.258c-.743-.15-1.729-1.36-2.692-3.282a11.893,11.893,0,0,1,3.338,2.359",
    transform: "translate(-16379.293 -15213.448)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6486",
    "data-name": "Path 6486",
    d: "M25.959,278.921a.2.2,0,0,0,.062.057c1.126.63,4.087,1.125,4.73.19a.955.955,0,0,0-.057-1.081c-1.172-2.021-4.537.344-4.68.445a.279.279,0,0,0-.107.23.271.271,0,0,0,.051.159m4.311-.664a1.267,1.267,0,0,1,.085.129c.124.214.152.37.086.467-.374.543-2.56.357-3.831-.145.853-.517,2.844-1.543,3.659-.451",
    transform: "translate(-16379.293 -15213.595)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6487",
    "data-name": "Path 6487",
    d: "M109.246,290.453a3.29,3.29,0,0,0,2.115-.531,1.152,1.152,0,0,0,.353-1.094.836.836,0,0,0-.412-.619c-1.176-.7-4.693,1.063-5.386,1.422a.186.186,0,0,0-.083.231.3.3,0,0,0,.217.2,16.358,16.358,0,0,0,3.2.4m1.412-1.964a.924.924,0,0,1,.467.1.266.266,0,0,1,.131.216.787.787,0,0,1-.243.757c-.564.505-2.124.572-4.24.2a11.887,11.887,0,0,1,3.886-1.266",
    transform: "translate(-16368.771 -15212.136)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6488",
    "data-name": "Path 6488",
    d: "M106.1,290.337a.2.2,0,0,0,.083-.017c1.178-.526,3.345-2.6,2.98-3.677a.954.954,0,0,0-.9-.6c-2.319-.268-2.435,3.843-2.44,4.018a.28.28,0,0,0,.12.225.275.275,0,0,0,.158.053m2.045-3.853a1.5,1.5,0,0,1,.156.009c.244.028.387.1.425.21.212.623-1.243,2.265-2.406,2.985.1-.993.462-3.2,1.826-3.2",
    transform: "translate(-16368.772 -15212.41)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6489",
    "data-name": "Path 6489",
    d: "M73.65,121.652c7.466.957,23.328,2.985,38.666,4.953,8.727-29.362,11.591-43.539,12.369-50.371a7.437,7.437,0,0,0-5.135-7.955c-2.312-.729-5.194-1.588-8.1-2.331-.995-.255-2-.5-2.987-.715A123.931,123.931,0,0,0,90.9,62.974c-.873-.074-1.74-.121-2.608-.17-1.712-.081-3.387-.112-4.95-.114a8.344,8.344,0,0,0-8.317,9.08c.3,3.431.54,6.571.723,9.477.434,6.79.564,12.265.467,17.038a147.272,147.272,0,0,1-2.568,23.367",
    transform: "translate(-16373.058 -15241.926)",
    fill: "#e89f33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9492",
    "data-name": "Group 9492",
    transform: "translate(-16299.411 -15179.236)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9491",
    "data-name": "Group 9491",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9490",
    "data-name": "Group 9490",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6490",
    "data-name": "Path 6490",
    d: "M73.65,121.652c7.466.957,23.328,2.985,38.666,4.953,8.727-29.362,11.591-43.539,12.369-50.371a7.437,7.437,0,0,0-5.135-7.955c-2.312-.729-5.194-1.588-8.1-2.331-.995-.255-2-.5-2.987-.715A123.931,123.931,0,0,0,90.9,62.974c-.873-.074-1.74-.121-2.608-.17-1.712-.081-3.387-.112-4.95-.114a8.344,8.344,0,0,0-8.317,9.08c.3,3.431.54,6.571.723,9.477.434,6.79.564,12.265.467,17.038a147.272,147.272,0,0,1-2.568,23.367",
    transform: "translate(-73.65 -62.69)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9495",
    "data-name": "Group 9495",
    transform: "translate(-16297.288 -15161.994)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9494",
    "data-name": "Group 9494",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9493",
    "data-name": "Group 9493",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6491",
    "data-name": "Path 6491",
    d: "M75.967,96.228c5.111-6.605,6.953-14.162,5.3-18.337l-5.767,1.3c.434,6.792.565,12.266.467,17.039",
    transform: "translate(-75.5 -77.891)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6492",
    "data-name": "Path 6492",
    d: "M109.882,65.947c-1-.261-2-.5-2.986-.727a125.626,125.626,0,0,0-17.563-2.259c-.874-.068-1.737-.114-2.6-.159l-1.51-.068,1.192,1.987c.159.272,4.019,6.585,13.669,13.374l2.055,1.431,1.976-1.51a14.922,14.922,0,0,0,6.222-11.955c-.148-.034-.307-.079-.454-.114",
    transform: "translate(-16371.507 -15241.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6493",
    "data-name": "Path 6493",
    d: "M93.1,52.994c-.361,4.779-1.487,9.648-4.261,11.689,0,0,3.539,5.891,12.716,12.336,5.745-4.395,4.842-10.085,4.842-10.085-6.107-2.312-5.692-6.505-3.1-13.258l-4.767-2.567A3.125,3.125,0,0,0,93.1,52.994",
    transform: "translate(-16371.03 -15243.568)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9498",
    "data-name": "Group 9498",
    transform: "translate(-16277.867 -15193.328)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9497",
    "data-name": "Group 9497",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9496",
    "data-name": "Group 9496",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6494",
    "data-name": "Path 6494",
    d: "M98.014,51.106a3.12,3.12,0,0,0-5.363,1.453,19.279,19.279,0,0,0,8.338,8.532,20.729,20.729,0,0,1,1.792-7.418Z",
    transform: "translate(-92.651 -50.077)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6495",
    "data-name": "Path 6495",
    d: "M86.112,41.4c2.369,9.228,3.176,13.183,8.814,17.07,8.481,5.845,19.3.916,19.731-8.834.392-8.775-3.549-22.391-13.4-24.348A12.994,12.994,0,0,0,86.112,41.4",
    transform: "translate(-16371.449 -15246.797)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6496",
    "data-name": "Path 6496",
    d: "M109.964,27.316A49.792,49.792,0,0,1,90.7,37.959s7.041,15-6.15,11.211c-3.825-12.772.054-19.395,3.365-22.517,10.5-3.406,17.881-4.541,22.045.662",
    transform: "translate(-16371.812 -15246.969)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6497",
    "data-name": "Path 6497",
    d: "M85.708,48.005a6.96,6.96,0,0,0,3.908,3.606c2.3.827,3.623-1.185,3.132-3.446-.442-2.034-2.168-4.917-4.546-4.769a3.128,3.128,0,0,0-2.494,4.609",
    transform: "translate(-16371.482 -15244.309)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6498",
    "data-name": "Path 6498",
    d: "M73.663,112.586l-2.188,3.238c-.169.251.114.565.561.623l40.553,5.2c.349.044.658-.09.71-.305l.792-3.416c.055-.237-.221-.479-.6-.528l-39.158-5.022a.707.707,0,0,0-.666.21",
    transform: "translate(-16373.351 -15235.322)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6499",
    "data-name": "Path 6499",
    d: "M77.7,117.612l-1.049-.134c-.209-.027-.354-.156-.322-.285l1.068-4.435c.031-.129.228-.213.436-.186l1.049.134c.209.026.354.154.324.285l-1.069,4.433c-.031.129-.227.215-.436.187",
    transform: "translate(-16372.468 -15235.29)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6500",
    "data-name": "Path 6500",
    d: "M105.207,121.14l-1.049-.134c-.209-.027-.354-.155-.322-.285l1.068-4.433c.031-.131.227-.215.436-.187l1.049.134c.209.027.354.154.324.285l-1.069,4.433c-.031.129-.227.215-.436.187",
    transform: "translate(-16369.028 -15234.824)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6501",
    "data-name": "Path 6501",
    d: "M91.452,119.376l-1.049-.134c-.209-.027-.354-.156-.322-.285l1.068-4.435c.032-.129.228-.213.437-.186l1.048.134c.209.027.354.154.324.285l-1.068,4.434c-.032.129-.228.215-.437.187",
    transform: "translate(-16370.85 -15235.056)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6502",
    "data-name": "Path 6502",
    d: "M99.989,39.284c.146.761.668,1.3,1.165,1.2s.781-.789.635-1.55-.668-1.3-1.165-1.2-.781.789-.635,1.55",
    transform: "translate(-16369.547 -15245.074)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6503",
    "data-name": "Path 6503",
    d: "M107.559,37.827c.146.761.668,1.3,1.165,1.2s.781-.789.635-1.55-.668-1.3-1.165-1.2-.781.789-.635,1.55",
    transform: "translate(-16368.543 -15245.274)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6504",
    "data-name": "Path 6504",
    d: "M107.927,36.456l1.725-.878s-.662,1.606-1.725.878",
    transform: "translate(-16368.487 -15245.368)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6505",
    "data-name": "Path 6505",
    d: "M105.553,39.145a20.68,20.68,0,0,0,3.643,4.331,3.33,3.33,0,0,1-2.612,1.03Z",
    transform: "translate(-16368.801 -15244.884)",
    fill: "#fca87e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6506",
    "data-name": "Path 6506",
    d: "M100.833,46.659a.227.227,0,0,0,.27.354,6.148,6.148,0,0,1,5.546-.019.227.227,0,0,0,.234-.389,6.486,6.486,0,0,0-5.979,0,.214.214,0,0,0-.072.054",
    transform: "translate(-16369.437 -15243.972)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6507",
    "data-name": "Path 6507",
    d: "M97.465,37.406a.452.452,0,0,0,.154-.177,3.624,3.624,0,0,1,2.574-2.04.455.455,0,0,0-.109-.9A4.512,4.512,0,0,0,96.8,36.829a.455.455,0,0,0,.662.578",
    transform: "translate(-16369.974 -15245.544)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6508",
    "data-name": "Path 6508",
    d: "M110.33,32.154a.343.343,0,0,0,.055-.066.456.456,0,0,0-.117-.632,4.514,4.514,0,0,0-4.1-.614.454.454,0,0,0,.344.841,3.607,3.607,0,0,1,3.245.522.455.455,0,0,0,.578-.051",
    transform: "translate(-16368.764 -15246.039)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6509",
    "data-name": "Path 6509",
    d: "M100.357,37.912l1.725-.878s-.662,1.606-1.725.878",
    transform: "translate(-16369.49 -15245.169)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6510",
    "data-name": "Path 6510",
    d: "M48.715,186.634a6.041,6.041,0,0,1-6.039-5.981c-.156-16.13,5.216-29.741,15.534-39.365,12.7-11.851,32.521-17.355,55.816-15.514,16.337,1.3,26.815-2.69,38.943-7.3,1.994-.757,4.009-1.524,6.075-2.276a6.04,6.04,0,0,1,4.133,11.351c-2.01.732-3.973,1.479-5.914,2.216-12.358,4.7-25.136,9.554-44.189,8.053-19.876-1.579-36.429,2.8-46.623,12.3-7.883,7.353-11.818,17.587-11.694,30.414a6.04,6.04,0,0,1-5.981,6.1Z",
    transform: "translate(-16377.022 -15234.941)",
    fill: "#3b9a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6511",
    "data-name": "Path 6511",
    d: "M152.125,147.646l24.313-8.905L160.809,96.074,136.5,104.98a8.16,8.16,0,0,0-4.841,10.438l10.032,27.387a8.159,8.159,0,0,0,10.438,4.841",
    transform: "translate(-16365.443 -15237.519)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9501",
    "data-name": "Group 9501",
    transform: "translate(-16234.288 -15141.443)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9500",
    "data-name": "Group 9500",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9499",
    "data-name": "Group 9499",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6512",
    "data-name": "Path 6512",
    d: "M152.125,147.646l24.313-8.905L160.809,96.074,136.5,104.98a8.16,8.16,0,0,0-4.841,10.438l10.032,27.387a8.159,8.159,0,0,0,10.438,4.841",
    transform: "translate(-131.161 -96.073)",
    fill: "#55deaa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9504",
    "data-name": "Group 9504",
    transform: "translate(-16215.55 -15141.441)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9503",
    "data-name": "Group 9503",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9502",
    "data-name": "Group 9502",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6513",
    "data-name": "Path 6513",
    d: "M147.729,100.042l10.843-3.973L174.2,138.742l-10.845,3.973a6.5,6.5,0,0,1-1.621-2.494L148.1,102.993a6.5,6.5,0,0,1-.372-2.951",
    transform: "translate(-147.692 -96.07)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5262",
    "data-name": "Rectangle 5262",
    width: 1.135,
    height: 7.557,
    transform: "translate(-16181.453 -15130.383) rotate(-20.115)",
    fill: "#4ec0c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6514",
    "data-name": "Path 6514",
    d: "M179.081,103.988l-3.835-10.47a9.266,9.266,0,0,0-8.677-6.051,9.155,9.155,0,0,0-3.157.561L156.5,90.559l-.391-1.067,6.907-2.531a10.366,10.366,0,0,1,13.291,6.167l3.835,10.469Z",
    transform: "translate(-16362.128 -15238.77)",
    fill: "#4ec0c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6515",
    "data-name": "Path 6515",
    d: "M173.3,143.911l10.113-3.7a6.4,6.4,0,0,0,3.8-8.193L173.3,94.019a6.4,6.4,0,0,0-8.193-3.8l-10.113,3.7a6.4,6.4,0,0,0-3.8,8.193l13.917,37.995a6.4,6.4,0,0,0,8.192,3.8",
    transform: "translate(-16362.844 -15238.343)",
    fill: "#3b9a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6516",
    "data-name": "Path 6516",
    d: "M166.881,102.859a3.406,3.406,0,1,1-4.37-2.027,3.406,3.406,0,0,1,4.37,2.027",
    transform: "translate(-16361.556 -15236.873)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6517",
    "data-name": "Path 6517",
    d: "M174.349,123.247a3.406,3.406,0,1,1-4.37-2.027,3.406,3.406,0,0,1,4.37,2.027",
    transform: "translate(-16360.565 -15234.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6518",
    "data-name": "Path 6518",
    d: "M89.143,127.824l-.1-.1c-1.773-1.772-3.647-3.7-5.331-5.657-1.72-1.949-3.354-3.948-4.857-5.993a55.89,55.89,0,0,1-4.039-6.257,32.986,32.986,0,0,1-2.182-4.85c.678-2.262,1.4-4.508,2.264-6.721.991-2.618,2.108-5.2,3.32-7.737s2.508-5.044,3.9-7.487q1.032-1.841,2.134-3.625l1.117-1.752c.355-.568.772-1.186,1.068-1.622l.127-.187a5.675,5.675,0,0,0-9.267-6.55c-.57.775-1,1.383-1.457,2.062-.455.663-.867,1.336-1.3,2q-1.248,2.015-2.4,4.064a90.1,90.1,0,0,0-4.162,8.442c-.644,1.431-1.2,2.905-1.785,4.362-.518,1.49-1.081,2.956-1.532,4.472a84.16,84.16,0,0,0-2.38,9.184l-.059.27a4.525,4.525,0,0,0,.181,2.487,37.034,37.034,0,0,0,4.343,8.216,54.208,54.208,0,0,0,5.611,6.773,69.687,69.687,0,0,0,6.349,5.739,66.675,66.675,0,0,0,7,4.886,2.824,2.824,0,0,0,3.438-4.427",
    transform: "translate(-16374.568 -15241.363)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6519",
    "data-name": "Path 6519",
    d: "M99.645,126.243l-.142-.3a7.069,7.069,0,0,0-4.964-3.856l-8.623-1.745-4.206,2.1c.45,4.714,7.2,7.54,7.2,7.54l1.916,2.193a3.956,3.956,0,0,0,5.267.623l2.28-1.617a3.957,3.957,0,0,0,1.275-4.945",
    transform: "translate(-16371.969 -15234.27)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6520",
    "data-name": "Path 6520",
    d: "M80.258,63.461c-4.777,2.193-9.873,9.769-9.873,9.769L80.648,92.366s11.622-13.392,10.64-20.09c-.834-5.686-4.944-11.61-11.031-8.816",
    transform: "translate(-16373.469 -15241.896)",
    fill: "#e89f33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9507",
    "data-name": "Group 9507",
    transform: "translate(-16303.089 -15179.148)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9506",
    "data-name": "Group 9506",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9505",
    "data-name": "Group 9505",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    d: "M80.258,63.461c-4.777,2.193-9.873,9.769-9.873,9.769L80.648,92.366s11.622-13.392,10.64-20.09c-.834-5.686-4.944-11.61-11.031-8.816",
    transform: "translate(-70.385 -62.747)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5264",
    "data-name": "Rectangle 5264",
    width: 450,
    height: 354.223,
    transform: "translate(-16383.278 -15250.487)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6522",
    "data-name": "Path 6522",
    d: "M379.429,316.714c-10,0-19.838-2.053-24.6-8.251-22.578-29.383-22.373-88.6-22.175-145.872.106-30.827,2.551-59.945-.883-82.567-2.025-13.336-9.04-22.5-16.219-27.225-10.577-6.966-25.117-3.225-31.327-1.626a6.022,6.022,0,1,1-3.02-11.658c7.764-2,25.951-6.677,41.007,3.24,10.154,6.686,18.943,18.62,21.5,35.468,3.576,23.537,1.128,53.106,1.021,84.41-.191,55.252-.387,112.385,19.685,138.51,1.619,2.108,7.964,3.993,18.448,3.455.927-.046,1.839-.111,2.733-.188a6.017,6.017,0,0,1,5.434-8.652c13.2,0,20.148,1.106,21.489,7.15.385,1.73.589,6.075-5.795,9.038-4.764,2.211-16.137,4.768-27.3,4.768",
    transform: "translate(-16346.445 -15245.22)",
    fill: "#3b9a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6523",
    "data-name": "Path 6523",
    d: "M252.228,291.865l-12.321-4.841,6.5-21.359,12.322,4.842Z",
    transform: "translate(-16351.019 -15215.165)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6524",
    "data-name": "Path 6524",
    d: "M241.613,283.344,255.49,288.8a.84.84,0,0,1,.522.91l-1.358,8.644a1.413,1.413,0,0,1-1.935,1.076c-3.484-1.438-8.936-3.819-13.356-5.555-2.718-1.068-7.884-2.772-11.638-4.247-3.673-1.443-2.786-5.38-1.117-5.112,7.484,1.2,10.351-.074,13.337-1.19a2.334,2.334,0,0,1,1.668.021",
    transform: "translate(-16352.996 -15212.795)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9512",
    "data-name": "Group 9512",
    transform: "translate(-16107.968 -14949.495)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9511",
    "data-name": "Group 9511",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9510",
    "data-name": "Group 9510",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6525",
    "data-name": "Path 6525",
    d: "M258.353,270.513l-12.326-4.843-3.344,11.012,12.325,4.843Z",
    transform: "translate(-242.683 -265.669)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6526",
    "data-name": "Path 6526",
    d: "M273.977,124.33s-11.145,55.112-15.413,82.288c-4.784,30.463-17.448,86.1-17.448,86.1l16.383,6.437s23.4-56.964,26.659-84.559c9.817-22.414,29.349-88.405,29.349-88.405Z",
    transform: "translate(-16350.958 -15234.291)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6527",
    "data-name": "Path 6527",
    d: "M240.423,273.538,258.4,280.6l3.074-5.446-20.105-8.332Z",
    transform: "translate(-16350.959 -15215.009)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6528",
    "data-name": "Path 6528",
    d: "M236.746,283.875a2.917,2.917,0,0,1-1.544-1.133,1.372,1.372,0,0,1,0-1.292.723.723,0,0,1,.6-.456c1.194-.12,3.378,2.787,3.624,3.119a.228.228,0,0,1-.215.361,11.323,11.323,0,0,1-2.466-.6m-.6-2.374a.65.65,0,0,0-.3-.055c-.068.007-.157.035-.232.2a.928.928,0,0,0-.014.882c.328.6,1.473,1.117,3.112,1.409a9.189,9.189,0,0,0-2.57-2.433",
    transform: "translate(-16351.643 -15213.092)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6529",
    "data-name": "Path 6529",
    d: "M238.839,284.624a.242.242,0,0,1-.091-.065c-.728-.867-1.747-3.531-1.167-4.453a.743.743,0,0,1,.893-.291,1.245,1.245,0,0,1,.795.627c.705,1.258-.094,3.924-.129,4.036a.224.224,0,0,1-.171.156.217.217,0,0,1-.129-.01m-.38-4.336a.933.933,0,0,0-.1-.032c-.287-.075-.361.043-.393.093-.344.544.215,2.474.861,3.534.192-.8.5-2.413.046-3.219a.811.811,0,0,0-.414-.377",
    transform: "translate(-16351.323 -15213.257)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9515",
    "data-name": "Group 9515",
    transform: "translate(-16061.553 -15076.146)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9514",
    "data-name": "Group 9514",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9513",
    "data-name": "Group 9513",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6530",
    "data-name": "Path 6530",
    d: "M292.252,153.753c-6.174,7.659-8.614,27.156-8.589,43.416,4.167-11.476,8.937-26.057,13.141-39.3Z",
    transform: "translate(-283.662 -153.753)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6531",
    "data-name": "Path 6531",
    d: "M317.845,293.206H304.607l-1.762-22.256h13.238Z",
    transform: "translate(-16342.677 -15214.45)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6532",
    "data-name": "Path 6532",
    d: "M305.453,289.574h14.91a.838.838,0,0,1,.819.656l1.9,8.542a1.414,1.414,0,0,1-1.408,1.71c-3.769-.065-9.714-.286-14.462-.286-2.921,0-8.352.3-12.385.3-3.945,0-4.562-3.988-2.91-4.349,7.4-1.62,9.607-3.854,11.978-5.985a2.333,2.333,0,0,1,1.56-.59",
    transform: "translate(-16344.274 -15211.931)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9518",
    "data-name": "Group 9518",
    transform: "translate(-16039.83 -14943.494)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9517",
    "data-name": "Group 9517",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9516",
    "data-name": "Group 9516",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6533",
    "data-name": "Path 6533",
    d: "M316.087,270.956H302.843l.915,11.471H317Z",
    transform: "translate(-302.843 -270.956)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M284.18,124.948s7.334,61.405,8.877,83.512c2.147,30.762,10.443,91.5,10.443,91.5h17.6s1.888-62.035-1.3-89.637c4.385-24.073,3-83.537,3-83.537Z",
    transform: "translate(-16345.195 -15234.209)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M300.771,280.225h19.318l.87-6.192-21.76-.4Z",
    transform: "translate(-16343.171 -15214.088)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6536",
    "data-name": "Path 6536",
    d: "M301.2,291.193a2.916,2.916,0,0,1-1.852-.489,1.372,1.372,0,0,1-.47-1.2.723.723,0,0,1,.389-.644c1.067-.548,4.163,1.359,4.513,1.577a.228.228,0,0,1-.067.416,11.362,11.362,0,0,1-2.514.344m-1.428-1.989a.641.641,0,0,0-.3.058c-.061.031-.133.09-.144.267a.929.929,0,0,0,.309.826c.527.441,1.78.5,3.413.173a9.213,9.213,0,0,0-3.282-1.324",
    transform: "translate(-16343.189 -15212.041)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    d: "M303.425,291.124a.231.231,0,0,1-.109-.027c-.995-.54-2.918-2.646-2.715-3.718a.744.744,0,0,1,.724-.6,1.257,1.257,0,0,1,.971.294c1.116.912,1.345,3.685,1.354,3.8a.227.227,0,0,1-.1.209.222.222,0,0,1-.124.037m-1.94-3.9a.807.807,0,0,0-.1.007c-.3.035-.321.171-.333.229-.12.632,1.1,2.224,2.094,2.976-.111-.811-.419-2.427-1.134-3.012a.809.809,0,0,0-.523-.2",
    transform: "translate(-16342.955 -15212.309)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6538",
    "data-name": "Path 6538",
    d: "M296.054,52.264h-.048L285.4,52.125c-3.558-.024-7.1-.1-10.608-.165-1.066-.022-2.113-.07-3.167-.11.058-.062.112-.126.17-.188.746-.792,1.493-1.611,2.268-2.392.381-.4.766-.8,1.152-1.19.36-.389.8-.821,1.051-1.133l.966-1.219a5.871,5.871,0,0,0-6.153-9.288l-2.1.568q-.981.3-1.938.62c-1.272.448-2.528.931-3.764,1.47a55.675,55.675,0,0,0-7.209,3.839,51.483,51.483,0,0,0-6.753,5.136,44.284,44.284,0,0,0-6.027,6.713,10.455,10.455,0,0,0-1.129,1.949,9.944,9.944,0,0,0,5.136,13.095l1.031.451a44.41,44.41,0,0,0,7.222,2.393c2.154.553,4.2.911,6.206,1.25s3.98.618,5.926.859q2.927.327,5.812.574c3.85.347,7.664.511,11.466.628,3.828.087,7.532.11,11.479-.067a11.834,11.834,0,0,0-.38-23.654",
    transform: "translate(-16350.92 -15245.279)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6539",
    "data-name": "Path 6539",
    d: "M298.689,71.239c-9.157,10.453-31.207,6.543-31.207,6.543l1.208-26.025A114.5,114.5,0,0,1,291.7,49.1c12.936-.028,14.324,13.768,6.989,22.14",
    transform: "translate(-16347.396 -15243.696)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6540",
    "data-name": "Path 6540",
    d: "M274.172,63.244c-.551,4.194-1.084,9.851-1.487,17.46-4.78,24.173-6.567,41.309-2.341,53.805,3.335,4.121,46.834,3.325,54.657,2.539,4.512-11.241,5.014-43.506,5.544-70.626a15.639,15.639,0,0,0-12.992-15.7,105.338,105.338,0,0,0-29.66-1,15.618,15.618,0,0,0-13.72,13.518",
    transform: "translate(-16347.391 -15243.732)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9521",
    "data-name": "Group 9521",
    transform: "translate(-16031.041 -15164.043)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9520",
    "data-name": "Group 9520",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9519",
    "data-name": "Group 9519",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6541",
    "data-name": "Path 6541",
    d: "M310.6,76.091c.145,8.275,6.136,21.478,12.877,28.171.411-6.982.677-14.556.882-22.191Z",
    transform: "translate(-310.603 -76.091)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6542",
    "data-name": "Path 6542",
    d: "M349.644,95.3l-.383-.915a86.165,86.165,0,0,0-5.556-10.969c-2.023-3.406-4.2-6.62-6.462-9.725-2.251-3.109-4.65-6.057-7.1-8.945-1.243-1.431-2.481-2.861-3.789-4.239l-1.969-2.071-2.127-2.108a11.825,11.825,0,0,0-17.115,16.307l.337.374,6.672,7.417c2.25,2.523,4.432,5.093,6.587,7.642,1.046,1.286,2.123,2.568,3.108,3.869,1.049,1.28,2.008,2.574,2.985,3.866,1.4,1.963,2.763,3.909,3.976,5.83a28.716,28.716,0,0,1-.695,2.876,84.671,84.671,0,0,1-2.871,8.11c-1.1,2.8-2.339,5.636-3.589,8.5s-2.6,5.781-3.786,8.616l-.107.25a5.969,5.969,0,0,0,9.536,6.71,94.394,94.394,0,0,0,7.12-7.355c2.233-2.561,4.354-5.234,6.385-8.068,1.015-1.416,1.972-2.9,2.926-4.419a52.112,52.112,0,0,0,2.718-4.825,45.8,45.8,0,0,0,2.388-5.589,25.565,25.565,0,0,0,1.45-7.623,8.436,8.436,0,0,0-.636-3.514",
    transform: "translate(-16343.006 -15243.229)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6543",
    "data-name": "Path 6543",
    d: "M313.881,50.69C329.2,53.3,339.174,74.039,339.174,74.039l-18.46,19.8s-10.641-10.834-17-20.866c-6.922-10.927-.807-24.153,10.165-22.282",
    transform: "translate(-16342.994 -15243.516)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6544",
    "data-name": "Path 6544",
    d: "M288.078,24.832c-2.557-4.295-3.382-10.244,1.3-16.241A4.788,4.788,0,0,1,284.7,6.359,28.2,28.2,0,0,1,302.961,0c13.748.007,14.774,5.3,14.3,8.925,9.395.6,16.253,25.053-7.577,29.372-13.631-14.4-21.61-13.466-21.61-13.466",
    transform: "translate(-16345.14 -15250.181)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    d: "M312.725,9.246s3.831-3.9-.931-8.634a6.4,6.4,0,0,1,4.475,4.453c.678,2.751-1.178,4.952-3.544,4.181",
    transform: "translate(-16341.475 -15250.101)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M310.586,31.065c-.363,7.523-1.038,16.084.221,22.1-1.951,3.07-6.945,6.612-15.9,7.407-3.188-1.806-7.384-6.216-5.922-8.489,3.809-2.442,5.419-9.838,4.326-15.361Z",
    transform: "translate(-16344.563 -15245.976)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9524",
    "data-name": "Group 9524",
    transform: "translate(-16051.256 -15213.494)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9523",
    "data-name": "Group 9523",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9522",
    "data-name": "Group 9522",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M305.679,32.316,292.754,36.55a20.489,20.489,0,0,1,.049,7.136c3.86-.125,9.215-3.039,11.219-5.765a7.162,7.162,0,0,0,1.657-5.6",
    transform: "translate(-292.754 -32.316)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M314.716,22.521c-2.4,9.232-3.329,14.757-8.983,18.633-8.506,5.831-19.205-.7-19.616-10.46-.37-8.786,3.609-22.408,13.481-24.344a13.01,13.01,0,0,1,15.118,16.17",
    transform: "translate(-16344.922 -15249.36)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M310.2,8.926c-4.046,2.886-9.079,15.1,1.189,20,9.127-8.053,6.751-20-1.189-20",
    transform: "translate(-16342.347 -15248.976)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M314.677,11.2C316.406,3.152,296.124-1,289.691,8.385c-2.174,5.622,23.755,10.653,24.985,2.81",
    transform: "translate(-16344.458 -15249.773)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M299.173,29.4l0,0a19.744,19.744,0,0,0-6.676-1.686.226.226,0,0,0-.241.251.312.312,0,0,0,.3.265,19.213,19.213,0,0,1,6.406,1.617.268.268,0,0,0,.35-.123.244.244,0,0,0-.134-.321",
    transform: "translate(-16344.063 -15246.433)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M314.386,30.286a9.073,9.073,0,0,1-6.311,2.849c-3.179.075-3.988-2.955-2.452-5.547,1.382-2.332,4.7-5.183,7.577-4.022,2.834,1.143,3.181,4.561,1.186,6.721",
    transform: "translate(-16342.401 -15247.029)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M298.59,20.614c-.149.761-.672,1.3-1.169,1.2s-.78-.792-.631-1.553.671-1.3,1.168-1.2.781.792.632,1.553",
    transform: "translate(-16343.458 -15247.604)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M291.015,19.137c-.149.761-.672,1.3-1.169,1.2s-.78-.792-.631-1.553.671-1.3,1.168-1.2.781.792.632,1.553",
    transform: "translate(-16344.463 -15247.802)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M293.724,19.754s-2.586,4.052-4.9,5.8c1.1,1.519,3.642,1.219,3.642,1.219Z",
    transform: "translate(-16344.519 -15247.508)",
    fill: "#fca87e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M297.321,16.538a.456.456,0,0,1,.455.14,3.626,3.626,0,0,0,3.022,1.3.455.455,0,0,1,.515.385.446.446,0,0,1-.385.515,4.51,4.51,0,0,1-3.835-1.6.454.454,0,0,1,.041-.643.449.449,0,0,1,.186-.1",
    transform: "translate(-16343.435 -15247.947)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M288.495,14.538a.444.444,0,0,1-.234-.157.455.455,0,0,1,.076-.639,4.505,4.505,0,0,1,4.061-.881.455.455,0,0,1,.285.577.463.463,0,0,1-.575.287,3.611,3.611,0,0,0-3.208.732.454.454,0,0,1-.405.081",
    transform: "translate(-16344.603 -15248.464)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M321.9,120.3l-9.756-.069,5.041,11.193s8.319-1.785,7.866-6.3Z",
    transform: "translate(-16341.441 -15234.285)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M307.83,127.906l1.6,3.155a3.789,3.789,0,0,0,4.781,1.8l3.616-1.443-5.041-11.193-3.875,2.95a3.786,3.786,0,0,0-1.083,4.729",
    transform: "translate(-16342.07 -15234.286)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M256.073,123.037a6.041,6.041,0,0,1-4.332-10.249c4.344-4.471,8.258-7.926,11.711-10.973,8.334-7.356,11.2-10.18,10.93-15.727-.125-2.547-1.114-6.177-2.157-10.022-2.484-9.133-5.3-19.482-.481-27.773,2.591-4.461,6.987-7.517,13.068-9.088a6.04,6.04,0,0,1,3.02,11.7c-4.274,1.1-5.3,2.877-5.643,3.459-2.28,3.925-.077,12.026,1.692,18.535,1.223,4.5,2.377,8.741,2.567,12.6.572,11.633-6.3,17.7-15,25.377-3.29,2.905-7.021,6.2-11.041,10.334a6.018,6.018,0,0,1-4.331,1.831",
    transform: "translate(-16349.717 -15244.901)",
    fill: "#3b9a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M267.243,36.91,276.7,34.5l-2.2,12.078s-8.5.266-9.148-4.223Z",
    transform: "translate(-16347.642 -15245.513)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M282.231,40.9l-.728,3.148a3.965,3.965,0,0,1-4.4,3.034l-3.7-.51,2.2-12.076,4.336,1.873a3.962,3.962,0,0,1,2.29,4.531",
    transform: "translate(-16346.568 -15245.514)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M219.375,133.315l-.266-.266a2.947,2.947,0,0,1,0-4.154L252.6,95.406a2.947,2.947,0,0,1,4.154,0l.266.266a2.946,2.946,0,0,1,0,4.154l-33.49,33.489a2.945,2.945,0,0,1-4.153,0",
    transform: "translate(-16353.922 -15237.705)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M234.728,148.668l-.266-.266a2.946,2.946,0,0,1,0-4.154l33.489-33.489a2.947,2.947,0,0,1,4.154,0l.266.266a2.947,2.947,0,0,1,0,4.154l-33.49,33.489a2.945,2.945,0,0,1-4.153,0",
    transform: "translate(-16351.887 -15235.677)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M284,118.107l-23.6,23.6-32.13-32.131,23.6-23.6a8.162,8.162,0,0,1,11.508,0L284,106.6a8.16,8.16,0,0,1,0,11.506",
    transform: "translate(-16352.628 -15239.166)",
    fill: "#3b9a76"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9527",
    "data-name": "Group 9527",
    transform: "translate(-16124.348 -15155.563)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9526",
    "data-name": "Group 9526",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9525",
    "data-name": "Group 9525",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M284,118.107l-23.6,23.6-32.13-32.131,23.6-23.6a8.162,8.162,0,0,1,11.508,0L284,106.6a8.16,8.16,0,0,1,0,11.506",
    transform: "translate(-228.277 -83.603)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9530",
    "data-name": "Group 9530",
    transform: "translate(-16124.319 -15137.801)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9529",
    "data-name": "Group 9529",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9528",
    "data-name": "Group 9528",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M236.439,99.283l-8.166,8.166,32.134,32.134,8.166-8.166a6.5,6.5,0,0,0-1.58-2.519l-28.035-28.035a6.517,6.517,0,0,0-2.519-1.58",
    transform: "translate(-228.273 -99.283)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M264.989,140.708l-.578.578a6.4,6.4,0,0,1-9.031,0l-28.611-28.611a6.4,6.4,0,0,1,0-9.03l.578-.579a6.406,6.406,0,0,1,9.031,0l28.611,28.611a6.4,6.4,0,0,1,0,9.032",
    transform: "translate(-16353.042 -15236.829)",
    fill: "#3b9a76"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5272",
    "data-name": "Rectangle 5272",
    width: 450,
    height: 354.223,
    transform: "translate(-16383.278 -15250.487)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordnotmatched);
export default __webpack_public_path__ + "static/media/passwordnotmatched.ba1d35b80058f1d0ef753fe35afc7715.svg";
export { ForwardRef as ReactComponent };